import { useSelector } from 'react-redux';
import DropdownArrow from '../../../../media/icons/assets_light/outline-action-dropdown-active.svg';

export default function SectionTabs({ activeTab, setActiveTab, mainSectionOpen, setMainSectionOpen }) {
  const { active_task } = useSelector(state => state.task);
  const toggleSection = (sectionKey) => {
    if (sectionKey === 'main_section') {
      if (typeof setMainSectionOpen === 'function') {
        setMainSectionOpen((prev) => !prev);
      }
    }
  };

  const baseClasses =
    "relative pb-1 text-sm font-medium text-gray-600 dark:!text-white hover:text-gray-800 transition-colors";

  const activeClasses =
    "relative text-teal-600 after:content-[''] after:absolute after:left-0 after:top-[32px] after:w-full after:h-[2px] after:bg-blue-500";

  return (
    <div className=' sticky top-0 z-[12] bg-white'>
      <div className="py-2 px-4 flex items-center justify-between border-t border-b border-gray-200">
        <div className="flex gap-8 items-end">
          <button onClick={() => setActiveTab("description")} className={`${baseClasses} ${activeTab === "description" ? activeClasses : ""}`} >
            Description
          </button>

          <button onClick={() => setActiveTab("files")} className={`${baseClasses} ${activeTab === "files" ? activeClasses : ""}`} >
            Files ({active_task?.files?.length || 0})
          </button>

          <button onClick={() => setActiveTab("discussion")} className={`${baseClasses} ${activeTab === "discussion" ? activeClasses : ""}`} >
            Discussion
          </button>
        </div>

        <div>
          <div
            onClick={() => toggleSection("main_section")}
            className={`relative top-[0px] right-[0px] w-[24px] h-[24px] bg-[#636E82] hover:!bg-surface-action cursor-pointer transition-colors transition-transform ${mainSectionOpen ? 'rotate-180' : ''}`}
            style={{
              WebkitMaskImage: `url(${DropdownArrow})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              WebkitMaskSize: "contain",
              maskImage: `url(${DropdownArrow})`,
              maskRepeat: "no-repeat",
              maskPosition: "center",
              maskSize: "contain",
            }}
          />
        </div>
      </div>
    </div>
  );
}
